import { enableMocking } from "@mocks/start";

enableMocking()
  .then(() => import("@app/bootstrap"))
  .catch(console.error);
